import "../SmcLife/IndexLife.css";
import "../SmcLife/2CroreTerm.css";
import "../SmcLife/HouseWifeTerm.css";
import TwoCrFamily from "../SmcLife/Images/2CroreTerm.svg";
import TaxBenepic from "../SmcLife/Images/Group2265.svg";
import hdfc from "../SmcLife/Images/HDFC_Life_Logo.png";
import TataAia from "../SmcLife/Images/TATA-AIA-Logo.png";

const TwoCroreTerm = () => {

    return (
        <div className="col-lg-7">
            <h4 className="Index-Plan TwoCr-main-heading">
                Comprehensive <span className="textcolor">2 Crore </span>Term Insurance Plans for <span className="textcolor">Complete </span>Financial Protection
            </h4>
            <p className="Index-Plan-Cont two-cr-index-plan">
                Secure Your Future with Affordable and Reliable Coverage Options
            </p>
            <div className="Added_PicTaxBenefitBox">
                <div className="row">
                    <div className="col-12">
                        <div className="MRN_imgBox">
                            <div className="TwoCrFamily_Img">
                                <img src={TwoCrFamily} alt="TwoCrFamily Insurance" />
                            </div>
                            <div className="TaxBenefits TaxBenefits3 TaxtBenefit2Cr">
                                <img src={TaxBenepic} alt="Get tax" />
                                <div className="GetLifeCNT">
                                    <p>Get tax benefits up to</p>
                                    <h2>₹ 1.5 Lakh</h2>
                                    <p>under section 80C</p>
                                </div>
                            </div>
                            <div className="brands-housewife brands-2cr">
                                <div className="allianceBox">
                                    <div className="alliances">
                                        {/* <img src={AegonLogo} alt="Aegon Logo" />*/}
                                        <img
                                            src="https://www.smcinsurance.com/insurer%20logo/aegon.jpg"
                                            className="" alt="Aegon"
                                        />
                                    </div>
                                    <div className="">
                                        <div className="alliances02">
                                            <img src={TataAia} alt="TataAia" />
                                        </div>
                                        <div className="alliances02"><span>+many more</span></div>
                                    </div>
                                    <div className="alliances">
                                        <img className="hdfc-logo" src={hdfc} alt="HDFC" />
                                    </div>
                                </div>
                                {/*<div className="review_box2">
                                                        <a className="review_box" href="/customer-reviews" target="_blank">
                                                            <div className="Google_rate">
                                                                <img src={Google} className="google_img" />
                                                                <img src={Rating} className="rating_img" />
                                                            </div>
                                                            <p>Highly rated insurance website</p>
                                                        </a>
                                                    </div>*/}
                            </div>

                        </div>
                    </div>
                    {/*  <div className="col-md-6">
                                            <div className="Family_lifesec women_life">
                                                <div>
                                                    <img src={WomenLife} className="imgtop m-auto" alt="Life Plan Image" />
                                                </div>
                                                
                                            </div>

                                            <div className="review_box2 review_box2_women">
                                                <a
                                                    className="review_box"
                                                    href="/customer-reviews"
                                                    target="_blank"
                                                >
                                                    <div className="indem-rate">
                                                        <img src={google} className="indem_googl" />
                                                        <img src={rattings} className="indem_star" />
                                                    </div>
                                                    <p>Highly rated insurance website</p>
                                                </a>
                                            </div>

                                        </div>*/}

                    <div className="col-md-6 p-0">
                        <ul className="partners_img partners_img2 partners_2cr">
                            <li className="partner_logo partner_logo1">
                                <span>
                                    <img
                                        src="https://www.smcinsurance.com/insurer%20logo/aegon.jpg"
                                        className="aegon_life" alt="aegon"
                                    />
                                </span>
                            </li>
                            <li className="partner_logo">
                                <span>
                                    <img src={hdfc} className="hdfc_life" alt="hdfc_life" />
                                </span>
                            </li>

                            <li className="partner_logo partner_logo1">
                                <span>
                                    <img src={TataAia} className="tata_aia" alt="tata_aia" />
                                </span>
                            </li>

                            <li className="Add_more">
                                <span>+many more</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default TwoCroreTerm;
